import Vue from "vue";
import App from "./App.vue";
import { Button, Message } from 'element-ui';
import router from "./router";

Vue.config.productionTip = false;
Vue.use({ Button, Message });
Vue.prototype.$message = Message;
// Vue.prototype.$system_url = 'https://static.acqtechpay.com';
Vue.prototype.$system_url = 'https://static-paymentapp.yzwlkjoa.online';
Vue.prototype.$api_url = 'https://test-paymentapp.yzwlkjoa.online';

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
